<template>
    <div class="income-material-statistics-page">
        <div class="df df-center">
            <a-select v-model:value="requestPayload.year" :options="yearOption" placeholder="请选择年度" @change="getData"
                allowClear style="width: 120px">
            </a-select>
        </div>

        <div class="statistics">
            <a-table :pagination="false" :columns="columns" :data-source="statisticsData" bordered
                style="width: 600px;">

            </a-table>
        </div>

        <div class="statistics" v-if="showChart">
            <pie-chart :option="chartOption" style="width: 600px;"></pie-chart>
        </div>
    </div>

</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import { getIncomingMaterialProblemSummary } from '@/request/view/dailyQualityInspection.js';
import { yearOption } from '@/views/productDaily/serve/option';
import { pieChartOption } from '@/views/afterSaleRepair/pc/statistics';
import pieChart from '@/views/afterSaleRepair/pc/pieChart.vue';
import { useRoute } from 'vue-router';

export default defineComponent({
    components: {
        pieChart
    },
    setup() {
        const chartOption = pieChartOption();
        // chartOption.title.text = '来料问题统计';
        chartOption.legend.top = '10';
        chartOption.series[0].radius = '50%';

        const showChart = ref(false);

        const route = useRoute();

        const statisticsData = reactive([]);

        const columns = [
            {
                title: '总计',
                dataIndex: '总计',
                align: "center",
            },
            {
                title: '现场处理',
                dataIndex: '现场处理',
                align: "center",
            },
            {
                title: '分析中',
                dataIndex: '分析中',
                align: "center",
            },
            {
                title: '进行中',
                dataIndex: '进行中',
                align: "center",
            },
            {
                title: '已完成',
                dataIndex: '已完成',
                align: "center",
            }
        ];

        const setChart = (data) => {
            statisticsData.length = 0;
            const chartDataList = [];

            const tableData = {
                总计: 0,
            };

            const seriesList = [
                {
                    name: '现场处理',
                    color: '#483D8B',
                },
                {
                    name: '分析中',
                    color: "#1E90FF",
                },
                {
                    name: "进行中",
                    color: "#FFD700",
                },
                {
                    name: "已完成",
                    color: "#42b983",
                }
            ];

            seriesList.forEach((item, index) => {
                const { name, color } = item;
                const value = data[name] ? data[name] : 0;
                tableData[name] = value;
                tableData['总计'] += value;
                chartDataList.push({
                    name,
                    value,
                    itemStyle: {
                        color
                    },
                    label: {
                        show: value > 0,
                    },
                    labelLine: {
                        show: value > 0,
                    }
                });
            });

            statisticsData.push(tableData);
            chartOption.series[0].data = chartDataList;
        };

        const requestPayload = reactive({
            year: new Date().getFullYear(),
            produceOrTpc: route.meta.produceOrTpc,
        });

        const getData = () => {
            showChart.value = false;
            if (!requestPayload.year) return;
            getIncomingMaterialProblemSummary(requestPayload).then((res) => {
                if (res.code === 200 && res.message === '成功' && Object.keys(res.data).length > 0) {
                    setChart(res.data);
                    showChart.value = true;
                }
            });
        }

        getData();

        return {
            columns,
            statisticsData,
            showChart,
            requestPayload,
            yearOption,
            getData,
            chartOption,
        };
    }
});
</script>

<style lang="less" scoped>
.income-material-statistics-page {
    height: calc(100vh - 200px);
    overflow-y: scroll;

    .statistics {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
}
</style>
